module.exports = __webpack_public_path__ + "media/application/images/IKG-logo-mobile-f0c5576a0a306fb0d57a83adb2bd3b05.svg";